export default {
  error: (state) => state.error,
  isLoading: (state) => state.isLoading,
  profile: (state) => state.profile,
  token: (state) => state.token,
  isAuthenticated: (state) => state.token !== '',
};
